import Vue from 'vue';
import Component from 'vue-class-component';
import { Meeting } from '@/content/models/meeting.model';
import { MEETINGS_EVENTS } from '@/content/values/events';
import { Prop } from 'vue-property-decorator';
import EdMeetings from '../../../components/common/ed-meetings/ed-meetings.vue';

@Component({
  components: {
    EdMeetings
  }
})
export default class EdPortalSidebar extends Vue {

  @Prop() readonly meetingOptions: any;

  /* Methods */
  public goToCreateMeeting() {
    this.$router.push({ name: this.meetingOptions.routes.CREATE_MEETING }).catch(() => {});
  }
  public goToEditMeeting(meeting: Meeting) {
    this.$router.push({ name: this.meetingOptions.routes.EDIT_MEETING, params: {meetingId: String(meeting.meetingId)} }).catch(() => {});
  }
  public goToMeetingDetail(meeting: Meeting) {
    this.$router.push({ name: this.meetingOptions.routes.MEETING_DETAIL, params: {meetingId: String(meeting.meetingId) } }).catch(() => {});
  }

  /* Hooks */
  public created() {
    this.$edEventBus.$on(MEETINGS_EVENTS.GO_TO_MEETING_DETAIL, this.goToMeetingDetail);
    this.$edEventBus.$on(MEETINGS_EVENTS.GO_TO_EDIT_MEETING, this.goToEditMeeting);
  }

}